mutation UpdateUserPreferences($extendedView: Boolean!) {
  updateUserPreferences(extendedView: $extendedView) {
    userPreferences {
      extendedView
    }
  }
}
